import axios from 'axios'
import { ADMIN_URL } from 'shared/app-settings';
import { authStorage } from 'shared/authStorage';

axios.interceptors.request.use(
    (config) => {
        const token = authStorage.getAccessToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const overviewService = {
    // Authentication APIs
    login(email, password) {
        const body = {
            email: email,
            password: password
        };
        return axios.post(ADMIN_URL + 'user/login', body, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    checkUserStatus(userId, accessToken) {
        const body = {
            userId: userId,
            access_token: accessToken
        };
        return axios.post(ADMIN_URL + 'user/checkUserStatus', body, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

    logout(userId, accessToken) {
        const body = {
            userId: userId,
            access_token: accessToken
        };
        return axios.post(ADMIN_URL + 'user/logout', body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        });
    },

    // Existing APIs
    getkhoahoc(body) {
        return axios.get(ADMIN_URL + 'allbaihocoverview', {
            params: body
        });
    },

    getallselider() {
        return axios.get(ADMIN_URL + 'getallslider');
    },
    getallbanner() {
        return axios.get(ADMIN_URL + 'getallbanner');
    },

    getallpopup() {
        return axios.get(ADMIN_URL + 'getallpopup');
    },

    getgeneraloverview(body) {
        return axios.get(ADMIN_URL + 'getgeneraloverview', {
            params: body
        });
    },

    getgioithieu(body) {
        return axios.get(ADMIN_URL + 'getgioithieu', {
            params: body
        });
    },

    getUserOnline() {
        return axios.get(ADMIN_URL + 'getUserOnline');
    },

    getallthongke(body) {
        return axios.get(ADMIN_URL + 'getallthongke', {
            params: body
        });
    },

    getallblog(body) {
        return axios.get(ADMIN_URL + 'getallblog', {
            params: body
        });
    },
    getallblognew(body) {
        return axios.get(ADMIN_URL + 'getallblognew', {
            params: body
        });
    },
    getallgioithieu(body) {
        return axios.get(ADMIN_URL + 'getallgioithieu', {
            params: body
        });
    },

    blogdetail(id) {
        return axios.get(ADMIN_URL + `blogdetail/${id}`);
    },
    useractivebaihoc(user_id) {
        var body = {
            user_id: user_id
        }
        return axios.get(ADMIN_URL + `useractivebaihoc`,
            {
                params: body
            }
        );
    },

    loadUrl(str) {
        var body = {
            strParam: str
        }
        return axios.post(ADMIN_URL + `lay-du-lieu-thanh-toan`, body);
    },

    getGeneralInfo() {
        return axios.get(ADMIN_URL + 'get-info-home');
    },

    registerStudent(email, fullname, school) {
        const body = {
            email: email,
            fullname: fullname,
            school: school
        };
        return axios.post(ADMIN_URL + 'register-student', body, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },

}
export { overviewService };